import css from 'styled-jsx/css';

const styles = css.global`.dropdown {
  border: 1px solid #767676;
  border-radius: 5px;
  height: 40px;
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.control,
.selected-value {
  display: flex;
  width: 100%;
}

.dropdown .arrow {
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 0;
  content: " ";
  display: block;
  height: 0;
  margin-top: 0.3rem;
  position: absolute;
  right: 10px;
  top: 14px;
  width: 0;
  pointer-events: none;
  cursor: pointer;
}

.dropdown .arrow.open {
  border-color: transparent transparent #999;
  border-width: 0 5px 5px;
}

.dropdown .selected-value input {
  border: none;
  width: 100%;
  padding: 0;
  margin: 0;
  outline: none;

  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #000;
  background: transparent;

  appearance: none;
  height: 100%;
  padding: 0 16px;
}

.dropdown .options,
.dropdown-inline.options {
  display: none;
  background-color: #fff;
  border: 1px solid #002C5F;
  margin-top: 6px;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
  border-radius: 5px;
  overflow-y: scroll;
  max-height: 310px;
  min-height: 50px;
  box-shadow: 6px 5px 13px #002C5F;
}

.dropdown-inline.options {
  position: static !important;
  top: unset;
  transform: unset;
}

.dropdown .options.open,
.dropdown-inline.options.open {
  display: block;
}

.dropdown .option,
.dropdown-inline .option {
  box-sizing: border-box;
  color: rgba(51, 51, 51, 0.8);
  cursor: pointer;
  display: block;
  padding: 8px 10px;
  font-family: 'SantanderText';
  font-weight: 400;
}

.dropdown .option.selected,
.dropdown .option:hover,
.dropdown-inline .option.selected,
.dropdown-inline .option:hover {
  background-color: #f2f9fc;
  color: #333;
}

.dropdown .placeholder {
  color: #444;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  padding: 0 16px;
}

.dropdown .control.select-only {
  height: 100%;
  align-items: center;
}

.dropdown .control.select-only .arrow,
.dropdown .control.select-only .selected-value {
  pointer-events: none !important;
}

.dropdown .option.disabled,
.dropdown-inline .option.disabled {
  color: #767676 !important;
}

.input-error-text {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #f14c4c;
  margin-bottom: 8px;
}

@media (min-width: 992px) {
  .dropdown {
    height: 54px;
  }

  .sn-select .ic-container {
    display: flex;
    height: 24px;
    width: 24px;
  }

  .dropdown .selected-value input {
    font-size: 18px;
    line-height: 26px;
  }

  .input-error-text {
    font-size: 18px;
    line-height: 26px;
  }

  .dropdown .arrow {
    top: 19px;
  }
}





.select-input-label {
  position: relative;
}

.select-input-label label {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  background: white;
  padding: 0 4px;
  transition: 0.2s ease;
  color: #444444;

  font-family: "SantanderText";
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
}

.select-input-label input:focus+label,
.select-input-label input.has-filled-value+label {
  top: 0;
  color: #444444;
  font-size: 14px;
  background: linear-gradient(to bottom, #f5f9fb 50%, transparent 50%);
}`;

export default styles;